import Mosaic from 'mosaic-framework';

export default new Mosaic({
    name: 'round-button',
    useShadow: true,
    created() {
        this.addEventListener('mouseover', this.onHover);
        this.addEventListener('mouseleave', this.onLeave);
        this.addEventListener('mousedown', this.onActive);
        this.addEventListener('mouseout', this.onLeave);
        this.addEventListener('mouseup', this.onUp);

        this.addEventListener('touchover', this.onHover);
        this.addEventListener('touchleave', this.onLeave);
        this.addEventListener('touchdown', this.onActive);
        this.addEventListener('touchout', this.onLeave);
        this.addEventListener('touchup', this.onUp);
    },
    willDestroy() {
        this.removeEventListener('mouseover', this.onHover);
        this.removeEventListener('mouseleave', this.onLeave);
        this.removeEventListener('mousedown', this.onActive);
        this.removeEventListener('mouseout', this.onLeave);
        this.removeEventListener('mouseup', this.onUp);

        this.removeEventListener('touchover', this.onHover);
        this.removeEventListener('touchleave', this.onLeave);
        this.removeEventListener('touchdown', this.onActive);
        this.removeEventListener('touchout', this.onLeave);
        this.removeEventListener('touchup', this.onUp);
    },
    onHover() {
        this.style.backgroundColor = '#5957c9';
    },
    onActive() {
        this.style.backgroundColor = '#211f78';
        this.style.top = '2px';
        this.style.boxSadow = '0px 3px 0px 0px #211f78';
    },
    onLeave() {
        this.style.backgroundColor = '#4341AE';
        this.style.top = '0px';
        this.style.boxSadow = '0px 5px 0px 0px #181759';
    },
    onUp() {
        this.style.backgroundColor = '#4341AE';
        this.style.top = '0px';
        this.style.boxSadow = '0px 5px 0px 0px #211f78';
    },
    view() {
        return html`
            <style>
                :host {
                    position: relative;
                    top: 0px;
                    color: white;
                    padding: 8px;
                    cursor: pointer;
                    user-select: none;
                    padding-left: 20px;
                    border-radius: 8px;
                    padding-right: 20px;
                    background-color: #4341AE;
                    -webkit-user-select: none;
                    transition-duration: 0.15s;
                    box-shadow: 0px 5px 0px 0px #211f78;
                }
                :host ion-icon {
                    position: relative;
                    top: 3px;
                }

                @media not screen and (min-width: 768px) {
                    :host {
                        display: block;
                        margin-left: 10%;
                        margin-right: 10%;
                    }
                }
            </style>

            ${this.descendants}
        `
    }
})